import React, { useContext } from "react";

import { LanguageContext } from "../../Contexts/Language";
import messages from "../../utils/messages";

export const Step4 = () => {
  const { lang } = useContext(LanguageContext);
  const { accountDeleted } = messages[lang];

  return (
    <div>
      <p
        style={{
          marginBottom: "5%",
        }}>
        {accountDeleted}
      </p>
    </div>
  );
};
